import { Box, IconButton } from '@wix/design-system';
import { ChevronLeft, ChevronRight } from '@wix/wix-ui-icons-common';
import React from 'react';

interface CarouselNavigationButtonsProps {
  showPrevButton: boolean;
  showNextButton: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

const CarouselNavigationButtons: React.FC<CarouselNavigationButtonsProps> = ({
  showPrevButton,
  showNextButton,
  onPrevious,
  onNext,
}) => {
  return (
    <>
      {showPrevButton && (
        <Box
          position="absolute"
          left="0"
          top="50%"
          transform="translateY(-50%)"
        >
          <IconButton
            onClick={onPrevious}
            skin="dark"
            size="small"
            dataHook="carousel-prev-button"
          >
            <ChevronLeft />
          </IconButton>
        </Box>
      )}

      {showNextButton && (
        <Box
          position="absolute"
          right="0"
          top="50%"
          transform="translateY(-50%)"
        >
          <IconButton
            onClick={onNext}
            skin="dark"
            size="small"
            dataHook="carousel-next-button"
          >
            <ChevronRight />
          </IconButton>
        </Box>
      )}
    </>
  );
};

export default CarouselNavigationButtons;
